import { DynFormSectionBase } from "../../common-shared-module/model/dyn-form/dyn-form-section.model"
import { LayoutMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/layout/layout-metadata.model"
import { SectionLayoutMetadataBase } from "../../common-shared-module/model/dyn-form/form-metadata/layout/section-layout.model"
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory"

export class HistoryChange {


    id: string
    change: string = ""
    _selectionId: string | null = null
    _sectionForm: DynFormSectionBase | null = null

    constructor() {
        this.id = "id" + Math.floor(Math.random() * 1000000)
    }

    toSectionLayoutMetadata(): SectionLayoutMetadataBase {
        let section = MetadataFactory.createSectionLayout()
        section.from(<LayoutMetadata> JSON.parse(this.change))
        return section
    }

    selectionId(): string | null {
        return this._selectionId
    }

    sectionNameAndRequired(name: string, required: boolean) {
        if (this._sectionForm) {
            this._sectionForm.name = name
            this._sectionForm.required = required
        }
    }

    sectionForm(): DynFormSectionBase {
        if (this._sectionForm == null) throw new Error('Section is null')
            return <DynFormSectionBase> this._sectionForm
    }

}


export class HistoryChangeBuilder {

    _section: SectionLayoutMetadataBase | null = null
    _selectionId: string | null = null
    _sectionForm: DynFormSectionBase | null = null

    section(section: SectionLayoutMetadataBase): HistoryChangeBuilder {
        this._section = section
        return this
    }

    selectionId(selectionId: string | null): HistoryChangeBuilder {
        this._selectionId = selectionId
        return this
    }

    sectionForm(sectionForm: DynFormSectionBase): HistoryChangeBuilder {
        this._sectionForm = sectionForm
        return this
    }

    build(): HistoryChange {
    
        let historyChange: HistoryChange = new HistoryChange()
        historyChange._selectionId = this._selectionId

        if (this._section) {
            historyChange.change = JSON.stringify(this._section)
        }

        if (this._sectionForm) {
            historyChange._sectionForm = this._sectionForm
        }

        return historyChange
    }

}